import { createSelector } from '@reduxjs/toolkit';
import { normalizeBatchFromBatches } from 'ducks/batch-definition/utils';
import { BatchDepDefinitionState } from 'ducks/batch-definition-dep/slices';
import { RootState } from 'store';

const batchDefinitionDepSlice = (state: RootState) => state.batch_definition_dep;
const batchDefinitionListSlice = (state: RootState) => state.batch_definition_list;

export const selectBatchDefinitionDep = createSelector(
  [batchDefinitionDepSlice],
  (state): BatchDepDefinitionState => state,
);

export const selectBatch = createSelector(
  [batchDefinitionListSlice, batchDefinitionDepSlice],
  (batch_definition_list, batch_definition_dep) =>
    normalizeBatchFromBatches(batch_definition_list, batch_definition_dep),
);
